import { useEffect } from "react";
import Lenis from "lenis";

// Smooth momentum scrolling — desktop mouse/trackpad only. Disabled for
// reduced-motion users and coarse-pointer (touch) devices: phones keep native
// scrolling, which stays natural on lower-powered hardware.
export function useLenis() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
}
